import { apiFetch } from './client';
import type { Comment } from '../types/mjai';

export interface CommentPayload {
  content: string;
  parent_comment_id?: string;
}

export async function getComments(handId: string): Promise<Comment[]> {
  return apiFetch<Comment[]>(`/comments/${handId}`);
}

export async function createComment(handId: string, payload: CommentPayload): Promise<Comment> {
  return apiFetch<Comment>(`/comments/${handId}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateComment(commentId: string, content: string): Promise<Comment> {
  return apiFetch<Comment>(`/comments/${commentId}`, {
    method: 'PATCH',
    body: JSON.stringify({ content }),
  });
}

export async function deleteComment(commentId: string): Promise<void> {
  await apiFetch<void>(`/comments/${commentId}`, { method: 'DELETE' });
}

export async function likeComment(commentId: string): Promise<{ like_count: number; is_liked: boolean }> {
  return apiFetch(`/comments/likes/${commentId}`, { method: 'POST' });
}

export async function unlikeComment(commentId: string): Promise<{ like_count: number; is_liked: boolean }> {
  return apiFetch(`/comments/likes/${commentId}`, { method: 'DELETE' });
}
